import React from "react";

import ValueCard from "./ValueCard";
import ModalInfo from "./ModalInfo";

class StrengthsActivity extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    strengthsSelected: 0,
    max: 5,
    pageTitle: "What are your strengths?",
    modalShow: true,
    instructions: (
      <div>
        <p>
          You are presented with 15 strengths which are particularly valued by
          employers. A short description will appear on your right as you hover
          a particular strength. In this interactive activity we will help you
          to identify your five top strengths. You may find it helpful to
          reflect on a time when you were really energised and immersed in a
          project, work or activity. Which strengths were you using?
        </p>
        <ol>
          <li>Select 5 strengths that energise you.</li>
          <li>
            If you change your mind, just click on the strength to remove it
            from your selection.
          </li>
          <li>
            When you are done click the{" "}
            <i
              className="fas fa-check-square fa-1x"
              style={{ color: "rgb(88, 99, 107)" }}
            ></i>{" "}
            button on the top right.
          </li>
        </ol>
        <p>
          Ps. If you need these instructions again, click on the{" "}
          <i
            className="fas fa-info-square fa-1x"
            style={{ color: "rgb(88, 99, 107)" }}
          ></i>{" "}
          button on the top right.
        </p>
      </div>
    ),
    warningModalShow: false,
    warning: (
      <div>
        <p></p>
      </div>
    ),
    data: require("./StrengthsData.json"),
    selectedStrengthsList: [],
  };

  componentDidMount() {
    if (this.props.alreadySelectedStrengths.length == 5) {
      for (var i = 0; i < this.inputRefs.length; i++) {
        this.inputRefs[i].deselectAlreadyDeselectedCards(
          this.props.alreadySelectedStrengths
        );
      }
      this.setState({
        strengthsSelected: 5,
        max: 0,
        pageTitle: "Your strengths are ...",
        instructions: (
          <div>
            <p>
              These are your 5 most essential strengths! <br />
              You can now continue to the next page.
            </p>
          </div>
        ),
      });
    }
  }

  inputRefs = [];
  setRef = (ref) => {
    this.inputRefs.push(ref);
  };

  addToSelectedList = (strength) => {
    let newlist = this.state.selectedStrengthsList;
    newlist.push(strength);
    this.setState({
      selectedStrengthsList: newlist,
    });
  };

  removeFromSelectedList = (strength) => {
    let newlist = this.state.selectedStrengthsList;
    let filteredList = newlist.filter(function (item) {
      return item !== strength;
    });
    this.setState({
      selectedStrengthsList: filteredList,
    });
  };

  strengthSelected = (strength) => {
    let s = this.state.strengthsSelected;
    s = s < this.state.max ? s + 1 : s;
    this.setState({
      strengthsSelected: s,
    });

    if (this.state.max == 5) {
      this.addToSelectedList(strength);
    }
  };
  strengthDeselected = (strength) => {
    let s = this.state.strengthsSelected;
    this.setState({
      strengthsSelected: s - 1,
    });

    if (this.state.max == 5) {
      this.removeFromSelectedList(strength);
    }
  };
  maxSelected = () => {
    this.setState({
      warningModalShow: true,
      warning: (
        <div>
          <p>You can only select {this.state.max} strengths.</p>
        </div>
      ),
    });
  };

  finishActivity = () => {
    if (this.state.strengthsSelected == this.state.max) {
      for (var i = 0; i < this.inputRefs.length; i++) {
        this.inputRefs[i].filteroutCard();
      }

      this.setState({
        strengthsSelected: 5,
        max: 0,
        pageTitle: "Your strengths are ...",
        instructions: (
          <div>
            <p>
              These are your 5 most essential strengths! <br />
              You can now continue to the next page.
            </p>
          </div>
        ),
      });
      this.props.onFinishingActivity(this.state.selectedStrengthsList);
    } else {
      this.setState({
        warningModalShow: true,
        warning: (
          <div>
            <p>You have to select exactly {this.state.max} strengths.</p>
          </div>
        ),
      });
    }
  };
  render() {
    let iconStyle =
      this.state.strengthsSelected == this.state.max
        ? {
            color: "rgb(30, 255, 0)",
          }
        : {};
    let modalClose = () => this.setState({ modalShow: false });
    let warningModalClose = () => this.setState({ warningModalShow: false });
    return (
      <div>
        <nav className="navbar fixed-top navbar-expand-sm bg-light page-title">
          <ul className="navbar-nav">
            <li className="nav-item">
              <h3 className="py-0  d-md-block">{this.state.pageTitle}</h3>
            </li>
            <li className="nav-item"></li>
          </ul>
          <ul className="nav navbar-nav ml-auto">
            <div>
              <i
                className="fas fa-info-square fa-3x"
                onClick={() => this.setState({ modalShow: true })}
              ></i>
              <i
                className="fas fa-check-square fa-3x"
                onClick={this.finishActivity}
                style={iconStyle}
              >
                {"  "}
                <span style={{ fontFamily: "Roboto, sans-serif" }}>
                  {this.state.strengthsSelected}
                </span>
              </i>
            </div>
          </ul>
        </nav>
        <div className="container">
          <div className="card-columns value-cards">
            {this.state.data.map(({ name, description }) => (
              <ValueCard
                key={name}
                ref={this.setRef}
                name={name}
                description={description}
                selectionHandler={this.strengthSelected}
                deselectionHandler={this.strengthDeselected}
                maxSelectionHandler={this.maxSelected}
                numCardsSelected={this.state.strengthsSelected}
                maxSelectable={this.state.max}
              />
            ))}
          </div>

          <br />
          <br />
          <br />
        </div>

        <ModalInfo
          show={this.state.modalShow}
          onHide={modalClose}
          title="INSTRUCTIONS"
          content={this.state.instructions}
        />
        <ModalInfo
          show={this.state.warningModalShow}
          onHide={warningModalClose}
          title="INSTRUCTIONS"
          content={this.state.warning}
        />
      </div>
    );
  }
}

export default StrengthsActivity;
